import styled from "@emotion/styled"
import Select from "react-select"

export const StyledSelect = styled(Select)`
  width: ${(props: any) => (props.width ? props.width : "")};
  height: ${(props: any) => (props.height ? props.height : "")};

  opacity: ${(props: any) => (props.isDisabled ? ".6" : "1")};

  &.react-select .react-select__control {
    border-color: ${(props: any) => (props.error ? "var(--chakra-colors-error)" : "var(--chakra-colors-input_border_color_primary)")};
  }
`
